<template>
  <Card>
    <div class="flex flex-wrap gap-3 mb-3 py-1">
      <Button
        v-for="(button, index) in buttons"
        :key="index"
        :label="button.title"
        :primary="button.color && button.color === 'blue'"
        :danger="button.color && button.color === 'red'"
        :alert="button.color && button.color === 'yellow'"
        :success="button.color && button.color === 'green'"
        :icon="button.icon"
        @click="selectButton(button)"
        class="h-[46px] flex-1"
        :class="selectedButtonColor(button.field, button.color)">
      </Button>
    </div>
  </Card>

  <template v-for="(button, index) in buttons" :key="index">
    <div class="py-3">
      <slot :key="index" v-if="selectedButton === button.field" :name="button.field"></slot>
    </div>
  </template>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  buttons: {
    type: Array,
    default: () => [],
  },
  modelValue: String,
})

const emit = defineEmits(['update:modelValue'])

const selectedButton = ref(props.modelValue || (props.buttons[0]?.field ?? ''))

const selectButton = (button) => {
  selectedButton.value = button.field
  emit('update:modelValue', selectedButton.value)
}

const selectedButtonColor = (buttonField, color) => {
  if (selectedButton.value === buttonField && color) {
    const selectedColors = {
      red: true,
      blue: 'bg-blue-800',
      yellow: 'bg-yellow-700',
      green: 'bg-green-700',
    }

    return selectedColors[color]
  }
  return ''
}

watch(
  () => props.modelValue,
  (newValue) => {
    selectedButton.value = newValue
  }
)
</script>
